import React, { useEffect, useRef, useState } from 'react'
import AllProductsStyle from './AllProducts'
import Button from '../../components/Button'
import { useNavigate } from 'react-router-dom'
import api, { customFuncsApi } from '../../api'
import { get } from 'lodash'
import Layout from '../../components/Layout'
import { ErrorModal } from '../../components/Modal'
import ClipLoader from 'react-spinners/ClipLoader'
import moment from 'moment'
import { roundCurrency } from '../../utils'
import { isAxiosError } from 'axios'
import _ from 'lodash'
import { sales } from '../../store/slices'
import { useDispatch, useSelector } from 'react-redux'
import customMainApi from '../../api/index'
import { formatNumberWithIntl } from '../../lib/FormatNumbersWithIntl'

const handleBusinessPartner = _.debounce((searchFunc, value) => {
	searchFunc(value)
}, 1000)

const Sales = () => {
	const { getMe } = useSelector((state) => state.main)
	const role = getMe?.Department2?.Name

	const {
		setClient: setClientStore,
		setImei: setImeiStore,
		setCardCode: setCardCodeStore,
		setPage: setPageStore,
		setStartDate,
		setEndDate,
	} = sales.actions
	const {
		client: clientStore,
		imei: imeiStore,
		cardCode: cardCodeStore,
		page: pageStore,
		startDate,
		endDate,
	} = useSelector((state) => state.sales)
	const dispatch = useDispatch()

	const navigation = useNavigate()
	const errorRef = useRef()

	const [isLoading, setIsLoading] = useState(false)
	const [clientLoading, setClientLoading] = useState(false)
	const [client, setClient] = useState(clientStore)
	const [clientCode, setClientCode] = useState(cardCodeStore)
	const [imeiClient, setImeiClient] = useState(imeiStore)
	const [product, setProduct] = useState('')
	const [data, setData] = useState([])
	const [currentPage, setCurrentPage] = useState(pageStore)
	const [clientsData, setClientsData] = useState([])
	const [userFields, setUserFields] = useState([])
	const [typeInvoice, setTypeInvoice] = useState('')
	const [whs, setWhs] = useState('')
	const [warehouseLoading, setWarehouseLoading] = useState(false)
	const [warehouses, setWarehouses] = useState([])
	const [dateStart, setDateStart] = useState(
		startDate || moment().startOf('year').format('YYYY-MM-DD'),
	)
	const [dateEnd, setDateEnd] = useState(
		endDate || moment().format('YYYY-MM-DD'),
	)

	const search = () => {
		setIsLoading(true)

		customFuncsApi
			.get(
				`XsSql/getInvoices?${
					(role === 'Sotuv' || role === 'Sotuv_sherik' || role === 'Sherik') &&
					imeiClient === '' &&
					client === ''
						? `WhsCode=${getMe?.U_Warehouse}`
						: `WhsCode=${whs}`
				}`,
				{
					params: {
						$skip: currentPage,
						IntrSerial: imeiClient || undefined,
						CardCode: client && clientCode ? clientCode : undefined,
						itemCode: product || undefined,
						type: typeInvoice,
						date1: moment(dateStart).format('YYYY-MM-DD'),
						date2: moment(dateEnd).format('YYYY-MM-DD'),
					},
					headers: {
						Prefer: 'odata.maxpagesize=10',
					},
				},
			)
			.then((res) => {
				const resData = res.data.value || []
				setData(resData)
				setIsLoading(false)
			})
			.catch((err) => {
				if (isAxiosError(err)) errorRef.current?.open(get(err, 'message', ''))
				setIsLoading(false)
			})
	}

	useEffect(() => {
		if (!client) {
			dispatch(setClientStore(client))
		}
	}, [client])

	useEffect(() => {
		userFieldsFn()
		getWarehouses()
	}, [])

	useEffect(() => {
		search()
	}, [currentPage])

	const userFieldsFn = () => {
		customMainApi
			.get('UserFieldsMD', {
				params: {
					$filter: "TableName eq 'OINV'",
					$select: 'Name,ValidValuesMD,TableName',
				},
			})
			.then((res) => {
				setUserFields(JSON.parse(res.data).value)
			})
	}

	const businessPartners = async (value) => {
		setClientLoading(true)
		api
			.get(`BusinessPartners`, {
				params: {
					$select: 'CardCode, CardName, U_Telephone',
					$filter: `contains(CardName, '${value}') or contains(U_Telephone, '${value}') or contains(CardCode, '${value}') and Frozen eq 'tNO'`,
				},
				headers: {
					Prefer: 'odata.maxpagesize=10',
				},
			})
			.then((res) => {
				setClientsData(JSON.parse(res.data).value || [])
				setClientLoading(false)
			})
			.catch((err) => {
				if (isAxiosError(err)) errorRef.current?.open(get(err, 'message', ''))
				setIsLoading(false)
			})
	}

	const viewItem = (v) => {
		navigation('/viewItem', { state: v })
	}

	const newDatas = () => {
		if (data.length >= 10) {
			setCurrentPage(currentPage + 10)
			dispatch(setPageStore(currentPage + 10))
		} else {
			alert('boshqa malumot yoq')
		}
	}

	const oldData = () => {
		if (data.oldPage < 0) {
			alert('boshqa malumot yoq')
		} else {
			setCurrentPage(currentPage - 10)
			dispatch(setPageStore(currentPage - 10))
		}
	}

	const getWarehouses = () => {
		setWarehouseLoading(true)
		customMainApi
			.get('Warehouses?$select=WarehouseCode,WarehouseName')
			.then((res) => {
				setWarehouses(JSON.parse(res.data).value)
			})
			.catch((err) => {
				if (err)
					errorRef.current?.open(
						JSON.stringify(err.response.data?.details?.message),
					)
			})
			.finally(() => {
				setWarehouseLoading(false)
			})
	}
	const handleSearch = () => {
		setCurrentPage(0)
		dispatch(setPageStore(0))
		search()
	}

	const switchTypeInvoice = (installmentId) => {
		if (installmentId <= 1) {
			return 'Наличные'
		} else {
			return 'Рассрочка'
		}
	}

	return (
		<Layout>
			<AllProductsStyle>
				<div className="container">
					<p className="productTitle">Продажи</p>
					<div className="flex items-end justify-betweens my-8">
						<div className="flex items-end gap-4 flex-wrap">
							<div className="flex flex-col gap-1">
								<p className="text-sm font-medium">Клиент</p>
								<div className="relative">
									<input
										className={
											'border-[1px] border-[#d9d9d9] p-2 rounded-md min-w-[250px]'
										}
										type="text"
										placeholder="Клиент"
										value={client}
										onChange={(e) => {
											setClient(e.target.value)
											handleBusinessPartner(businessPartners, e.target.value)
										}}
									/>
									{client && (
										<div className="absolute top-10 left-0 bg-white w-full z-10 border-[1px] border-[#d9d9d9] max-h-[300px] overflow-y-scroll">
											{clientsData.map((v, i) => {
												return (
													<div
														key={i}
														className="p-2 border-b cursor-pointer hover:bg-gray-100"
														onClick={() => {
															dispatch(setCardCodeStore(v.CardCode))
															dispatch(setClientStore(v.CardName))
															setClientCode(v.CardCode)
															setClient(v.CardName)
															setClientsData([])
														}}
													>
														{v.CardName}
													</div>
												)
											})}
										</div>
									)}
								</div>
							</div>
							<div className="flex flex-col gap-1">
								<p className="text-sm font-medium">IMEI</p>
								<input
									className={
										'border-[1px] border-[#d9d9d9] h-10 p-2 rounded-md w-[150px]'
									}
									type="text"
									placeholder="Имеи"
									defaultValue={imeiClient}
									onChange={(v) => {
										setImeiClient(v.target.value)
										dispatch(setImeiStore(v.target.value))
									}}
								/>
							</div>
							<div className="flex flex-col gap-1">
								<p className="text-sm font-medium">Дата начала</p>
								<input
									type="date"
									className={
										'border-[1px] border-[#d9d9d9] p-2 rounded-md w-full'
									}
									value={dateStart}
									onChange={(v) => {
										dispatch(setStartDate(v.target.value))
										setDateStart(v.target.value)
									}}
									max={dateEnd}
								/>
							</div>
							<div className="flex flex-col gap-1">
								<p className="text-sm font-medium">Дата окончания</p>
								<input
									type="date"
									className={
										'border-[1px] border-[#d9d9d9] p-2 rounded-md w-full'
									}
									value={dateEnd}
									onChange={(v) => {
										dispatch(setEndDate(v.target.value))
										setDateEnd(v.target.value)
									}}
									min={dateStart}
								/>
							</div>
							<div className="flex flex-col gap-1">
								<p className="text-sm font-medium">Условия продажи</p>
								<select
									className="border-[1px] border-[#d9d9d9] p-2 h-10 min-w-[150px] rounded-md"
									value={typeInvoice}
									placeholder="Условия продажи"
									onChange={(e) => setTypeInvoice(e.target.value)}
								>
									<option value="">Все</option>
									<option value="oneinst">Наличные</option>
									<option value="manyinst">Рассрочка</option>
								</select>
							</div>
							{role !== 'Sotuv' &&
								role !== 'Sotuv_sherik' &&
								role !== 'Sotuv_Andijon' &&
								role !== 'Sherik' && (
									<div className="flex flex-col gap-1">
										<p className="text-sm font-medium">Филиал</p>
										<select
											className="border-[1px] border-[#d9d9d9] p-2 h-10 min-w-[150px] rounded-md"
											value={whs}
											placeholder="Филиал"
											onChange={(e) => setWhs(e.target.value)}
										>
											<option value="">Все</option>
											{warehouses.map((v, i) => {
												return (
													<option key={i} value={v.WarehouseCode}>
														{v.WarehouseName}
													</option>
												)
											})}
										</select>
									</div>
								)}

							<Button
								className="!h-10"
								onClick={() => handleSearch()}
								isLoading={isLoading}
							>
								Поиск
							</Button>
						</div>
					</div>

					{!['Undiruvchi1', 'Undiruvchi2', 'Undiruvchi3', 'Undiruv'].includes(
						role,
					) && (
						<div className="flex justify-end items-center gap-1 mb-6">
							<Button onClick={() => navigation('/createProducts-payment')}>
								Добавить наличные
							</Button>
							<Button onClick={() => navigation('/createProducts-installment')}>
								Добавить рассрочку
							</Button>
						</div>
					)}

					{isLoading ? (
						<ClipLoader
							loading={true}
							size={75}
							aria-label="Loading Spinner"
							className={'loader'}
							data-testid="loader"
						/>
					) : (
						<>
							<div className="overflow-y-auto mb-8">
								<table className="w-full text-sm text-left rtl:text-right text-gray-500 ">
									<thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
										<tr>
											<th scope="col" className="px-6 py-4">
												Дата продажи
											</th>
											<th scope="col" className="px-6 py-4">
												Имя Клиента
											</th>
											<th scope="col" className="px-6 py-4">
												Товар
											</th>
											<th scope="col" className="px-6 py-4">
												Имеи
											</th>
											<th scope="col" className="px-6 py-4">
												Условия продажи
											</th>

											{role !== 'Undiruvchi1' && (
												<th scope="col" className="px-6 py-4">
													Сумма
												</th>
											)}
											<th scope="col" className="px-6 py-4">
												Филиал
											</th>
										</tr>
									</thead>
									<tbody>
										{data.map((v, i) => {
											return (
												<tr
													key={i}
													onClick={() => {
														// if (role === 'Undiruvchi1') return
														viewItem(v)
													}}
													className="bg-white border-b  hover:bg-gray-50 "
												>
													<td className="px-6 py-4">
														{moment(get(v, 'DocDate', '-')).format(
															'DD-MM-YYYY',
														)}
													</td>
													<td className="px-6 py-4">
														{get(v, 'CardName', '-')}
													</td>
													<td className="px-6 py-4">
														{get(v, 'Dscription', '-')}
													</td>
													<td className="px-6 py-4">
														{get(v, 'IntrSerial', '-')}
													</td>
													<td className="px-6 py-4">
														{switchTypeInvoice(get(v, 'Installmnt', '-'))}
													</td>

													{role !== 'Undiruvchi1' && (
														<td className="px-6 py-4">
															{formatNumberWithIntl(get(v, 'DocTotal', '-'))}
														</td>
													)}
													<td className="px-6 py-4">
														{get(v, 'WhsCode', '-')}
													</td>
												</tr>
											)
										})}
									</tbody>
								</table>
							</div>
							<div className="topCard">
								<div className="flex items-center gap-2 ">
									<Button
										disabled={currentPage === 0}
										className={'btn'}
										onClick={oldData}
									>
										{'<'}
									</Button>
									<p>{currentPage / 10 + 1}</p>
									<Button
										disabled={data.length < 10}
										className={'btn'}
										onClick={newDatas}
									>
										{'>'}
									</Button>
								</div>
							</div>
						</>
					)}
				</div>
			</AllProductsStyle>
			<>
				<ErrorModal
					getRef={(r) => {
						errorRef.current = r
					}}
				/>
			</>
		</Layout>
	)
}

export default Sales
